import clsx from 'clsx'
import { memo } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

import { SubscriptionBadge } from '@entities/subscription'

import { useTgAuth } from '@shared/lib/useTgAuth'
import { useTgData } from '@shared/lib/useTgData'
import { getDayJs } from '@shared/lib/utils'
import { Btn } from '@shared/ui/btn'

import styles from './styles.module.scss'

//
//

const dayjs = getDayJs()

//
//

const FCHeader = () => {
  const { t } = useTranslation()

  //
  //

  const auth = useTgAuth()
  const { isReady, close: closeTgApp } = useTgData()

  //
  //

  const currentPageIsHome = window.location.pathname === '/'

  //
  //

  const goToSubscribe = () => {
    if (!isReady) {
      return
    }

    closeTgApp()
  }

  //
  //

  let subscriptionInfoContent

  if (auth.data?.package?.expiresAt === false || auth.data?.package.isExpired) {
    subscriptionInfoContent = (
      <Btn onClick={goToSubscribe}>{t('general:subscribe')}</Btn>
    )
  } else if (auth.data?.package?.expiresAt === null) {
    subscriptionInfoContent = (
      <SubscriptionBadge title={t('general:unlimitedSubscription')}>
        ∞
      </SubscriptionBadge>
    )
  } else {
    subscriptionInfoContent = (
      <SubscriptionBadge title={t('general:prolongateSubscription')}>
        {dayjs(auth.data.package.expiresAt).diff(dayjs(), 'days')}{' '}
        {t('general:days')}
      </SubscriptionBadge>
    )
  }

  //
  //

  return (
    <Container className={clsx(styles['header-container'])}>
      <header className={clsx(styles.header)}>
        <Row className={styles.header__row}>
          <Col xs={4} className={styles['header__account-info']}>
            {subscriptionInfoContent}
          </Col>
          {!currentPageIsHome && (
            <Col xs={4} className={styles['header__home-btn']}>
              <Btn design={['wrapper']} link="/">
                <i className="fa-solid fa-home fa-lg" />
              </Btn>
            </Col>
          )}
          <Col
            xs={{ span: 4, offset: !currentPageIsHome ? 0 : 4 }}
            className={styles['header__user-info']}
          >
            <img src={auth.data.user.tgPhotoUrl} alt="User Avatar" />
            {/* <img src="/images/anna-profile-photo.jpg" alt="User Avatar" /> */}
            <div>{auth.data.user.tgFirstName || '-'}</div>
            {/* <div>Anna</div> */}
          </Col>
        </Row>
      </header>
    </Container>
  )
}
export const Header = memo(FCHeader)
